(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(39594);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 70820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);


function SliceManager(param) {
    var slicesClassName = param.slicesClassName, mapSliceTypeToComponent = param.mapSliceTypeToComponent, slicesData = param.slicesData;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: slicesData === null || slicesData === void 0 ? void 0 : slicesData.map(function(sliceData, index) {
            var SliceComponent = mapSliceTypeToComponent === null || mapSliceTypeToComponent === void 0 ? void 0 : mapSliceTypeToComponent[sliceData === null || sliceData === void 0 ? void 0 : sliceData.type];
            if (!SliceComponent) return null;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SliceComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                className: slicesClassName,
                index: index
            }, sliceData === null || sliceData === void 0 ? void 0 : sliceData.data), index);
        })
    });
}
SliceManager.defaultProps = {};
/* harmony default export */ __webpack_exports__["Z"] = (SliceManager);


/***/ }),

/***/ 39594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./src/lib/storyblok-types.ts
var storyblok_types = __webpack_require__(18685);
// EXTERNAL MODULE: ./src/components/Slices/BigTitle/index.tsx
var BigTitle = __webpack_require__(55734);
// EXTERNAL MODULE: ./src/components/Slices/EditorialTitleParagraphCta/index.tsx
var EditorialTitleParagraphCta = __webpack_require__(76791);
// EXTERNAL MODULE: ./src/components/Slices/HeroSlider/index.tsx + 1 modules
var HeroSlider = __webpack_require__(88860);
// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__(19845);
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsHover/index.js
var useIsHover = __webpack_require__(61356);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useSpring/index.js + 2 modules
var useSpring = __webpack_require__(11624);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useIsomorphicLayoutEffect/index.js
var useIsomorphicLayoutEffect = __webpack_require__(56346);
// EXTERNAL MODULE: ./src/components/Abstracts/Video/index.tsx
var Video = __webpack_require__(49013);
// EXTERNAL MODULE: ./src/components/Abstracts/Icons/index.tsx + 15 modules
var Icons = __webpack_require__(1815);
// EXTERNAL MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/MuteUnmuteButton/styles.module.scss
var styles_module = __webpack_require__(60731);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/MuteUnmuteButton/index.tsx





var cx = bind_default().bind((styles_module_default()));
function MuteUnmuteButton(param) {
    var className = param.className, videoHandleMuteUnmute = param.videoHandleMuteUnmute, videoMuted = param.videoMuted, color = param.color, mutedIcon = param.mutedIcon, soundIcon = param.soundIcon;
    var MutedComponent = mutedIcon !== null && mutedIcon !== void 0 ? mutedIcon : Icons/* MutedIcon */.QQ;
    var SoundComponent = soundIcon !== null && soundIcon !== void 0 ? soundIcon : Icons/* SoundIcon */.yI;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: cx((styles_module_default()).MuteUnmuteButton, className),
        onClick: videoHandleMuteUnmute,
        children: videoMuted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MutedComponent, {
            fill: color
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SoundComponent, {
            fill: color
        })
    });
}
MuteUnmuteButton.defaultProps = {
    color: "#000000"
};
/* harmony default export */ var VideoControls_MuteUnmuteButton = (MuteUnmuteButton);

// EXTERNAL MODULE: ./src/components/Abstracts/Spinner/index.tsx
var Spinner = __webpack_require__(87407);
// EXTERNAL MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/PlayPauseButton/styles.module.scss
var PlayPauseButton_styles_module = __webpack_require__(14583);
var PlayPauseButton_styles_module_default = /*#__PURE__*/__webpack_require__.n(PlayPauseButton_styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/PlayPauseButton/index.tsx






var PlayPauseButton_cx = bind_default().bind((PlayPauseButton_styles_module_default()));
function PlayPauseButton(param) {
    var className = param.className, videoHandlePausePlay = param.videoHandlePausePlay, videoPaused = param.videoPaused, videoIsLoading = param.videoIsLoading, color = param.color, playIcon = param.playIcon, pauseIcon = param.pauseIcon;
    var PlayComponent = playIcon !== null && playIcon !== void 0 ? playIcon : Icons/* PlayIcon */.o1;
    var PauseComponent = pauseIcon !== null && pauseIcon !== void 0 ? pauseIcon : Icons/* PauseIcon */.fp;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: PlayPauseButton_cx((PlayPauseButton_styles_module_default()).PlayPauseButton, className),
        onClick: videoHandlePausePlay,
        children: videoIsLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {}) : videoPaused ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayComponent, {
            fill: color
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PauseComponent, {
            fill: color
        })
    });
}
PlayPauseButton.defaultProps = {
    color: "#000000"
};
/* harmony default export */ var VideoControls_PlayPauseButton = (PlayPauseButton);

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs
var use_motion_value = __webpack_require__(4960);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 19 modules
var motion_minimal = __webpack_require__(57891);
// EXTERNAL MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useOnResize/index.js
var useOnResize = __webpack_require__(94302);
;// CONCATENATED MODULE: ./node_modules/@unlikelystudio/react-hooks/dist/es/useMeasure/index.js
function n(e){const[o,i]=(0,react.useState)({x:0,y:0,width:0,height:0,left:0,right:0,top:0,bottom:0});return (0,useOnResize/* useOnResize */.TT)(()=>{if(e.current){const t=e.current.getBoundingClientRect();i({width:t.width,height:t.height,top:t.top,left:t.left,right:t.right,bottom:t.bottom,x:t.x,y:t.y})}}),o}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./src/hooks/useRelativePosition/index.ts
var useRelativePosition = __webpack_require__(25385);
// EXTERNAL MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/ProgressBar/styles.module.scss
var ProgressBar_styles_module = __webpack_require__(45592);
var ProgressBar_styles_module_default = /*#__PURE__*/__webpack_require__.n(ProgressBar_styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/ProgressBar/index.tsx









var ProgressBar_cx = bind_default().bind((ProgressBar_styles_module_default()));
function ProgressBar(param) {
    var className = param.className, videoProgress = param.videoProgress, videoDuration = param.videoDuration, videoHandleSeekTo = param.videoHandleSeekTo, backgroundColor = param.backgroundColor, color = param.color, height = param.height;
    var videoProgressWrapper = (0,react.useRef)();
    var progessBarBounds = n(videoProgressWrapper);
    var ref = (0,useRelativePosition/* default */.ZP)(), mousePosition = ref.position, bindEvents = ref.bindEvents;
    var scaleX = (0,use_motion_value/* useMotionValue */.c)(0);
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        !isNaN(videoProgress) && (videoProgressWrapper === null || videoProgressWrapper === void 0 ? void 0 : videoProgressWrapper.current) && scaleX.set(videoProgress);
    }, [
        videoProgress
    ]);
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        if (!progessBarBounds) return;
        var width = progessBarBounds.width;
        if (!width) return;
        var percent = mousePosition.x / width;
        videoHandleSeekTo(percent * videoDuration);
    }, [
        mousePosition
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: ProgressBar_cx((ProgressBar_styles_module_default()).ProgressBar, className),
        ref: videoProgressWrapper
    }, bindEvents), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: ProgressBar_cx((ProgressBar_styles_module_default()).videoProgressContent),
            style: {
                backgroundColor: backgroundColor,
                height: "".concat(height, "px")
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                className: ProgressBar_cx((ProgressBar_styles_module_default()).videoProgressBar),
                style: {
                    backgroundColor: color,
                    scaleX: scaleX
                }
            })
        })
    }));
}
ProgressBar.defaultProps = {
    color: "#000000",
    backgroundColor: "#0000001a",
    height: "2"
};
/* harmony default export */ var VideoControls_ProgressBar = (ProgressBar);

// EXTERNAL MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/styles.module.scss
var VideoControls_styles_module = __webpack_require__(60844);
var VideoControls_styles_module_default = /*#__PURE__*/__webpack_require__.n(VideoControls_styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/VideoPlayer/VideoControls/index.tsx







var VideoControls_cx = bind_default().bind((VideoControls_styles_module_default()));
function VideoControls(param) {
    var className = param.className, videoMuted = param.videoMuted, videoPaused = param.videoPaused, videoProgress = param.videoProgress, videoDuration = param.videoDuration, videoIsLoading = param.videoIsLoading, videoHandlePausePlay = param.videoHandlePausePlay, videoHandleMuteUnmute = param.videoHandleMuteUnmute, videoHandleSeekTo = param.videoHandleSeekTo, videoIsHover = param.videoIsHover, playPauseButtonClassName = param.playPauseButtonClassName, muteUnmuteButtonClassName = param.muteUnmuteButtonClassName, progressBarClassName = param.progressBarClassName, theme = param.theme, playIcon = param.playIcon, pauseIcon = param.pauseIcon, soundIcon = param.soundIcon, mutedIcon = param.mutedIcon;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: VideoControls_cx((VideoControls_styles_module_default()).VideoControls, className, {
            hide: !videoIsHover
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoControls_PlayPauseButton, {
                className: VideoControls_cx((VideoControls_styles_module_default()).playpausebutton, playPauseButtonClassName),
                videoHandlePausePlay: videoHandlePausePlay,
                videoPaused: videoPaused,
                videoIsLoading: videoIsLoading,
                color: (theme === null || theme === void 0 ? void 0 : (ref = theme.playPauseButton) === null || ref === void 0 ? void 0 : ref.color) || "#000000",
                playIcon: playIcon,
                pauseIcon: pauseIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoControls_MuteUnmuteButton, {
                className: VideoControls_cx((VideoControls_styles_module_default()).muteunmutebutton, muteUnmuteButtonClassName),
                videoHandleMuteUnmute: videoHandleMuteUnmute,
                videoMuted: videoMuted,
                color: (theme === null || theme === void 0 ? void 0 : (ref1 = theme.muteUnmuteButton) === null || ref1 === void 0 ? void 0 : ref1.color) || "#000000",
                soundIcon: soundIcon,
                mutedIcon: mutedIcon
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoControls_ProgressBar, {
                className: VideoControls_cx((VideoControls_styles_module_default()).progressbar, progressBarClassName),
                videoProgress: videoProgress,
                videoDuration: videoDuration,
                videoHandleSeekTo: videoHandleSeekTo,
                backgroundColor: (theme === null || theme === void 0 ? void 0 : (ref2 = theme.progressBar) === null || ref2 === void 0 ? void 0 : ref2.backgroundColor) || "#0000001a",
                color: (theme === null || theme === void 0 ? void 0 : (ref3 = theme.progressBar) === null || ref3 === void 0 ? void 0 : ref3.color) || "#000000"
            })
        ]
    });
}
VideoControls.defaultProps = {};

/* harmony default export */ var VideoPlayer_VideoControls = (VideoControls);

// EXTERNAL MODULE: ./src/components/Abstracts/VideoPlayer/VideoPlayerBasic/styles.module.scss
var VideoPlayerBasic_styles_module = __webpack_require__(42296);
var VideoPlayerBasic_styles_module_default = /*#__PURE__*/__webpack_require__.n(VideoPlayerBasic_styles_module);
;// CONCATENATED MODULE: ./src/components/Abstracts/VideoPlayer/VideoPlayerBasic/index.tsx











var VideoPlayerBasic_cx = bind_default().bind((VideoPlayerBasic_styles_module_default()));
function VideoPlayerBasic(_param) {
    var className = _param.className, src = _param.src, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "src"
    ]);
    var ref = (0,react.useState)(rest.autoPlay), isPlaying = ref[0], setIsPlaying = ref[1];
    var ref1 = (0,react.useState)(rest.muted), isMuted = ref1[0], setIsMuted = ref1[1];
    var ref2 = (0,react.useState)(false), metaDataLoaded = ref2[0], setMetaDataLoaded = ref2[1];
    var ref3 = (0,react.useState)(), videoProgress = ref3[0], setVideoProgress = ref3[1];
    var ref4 = (0,react.useState)(), duration = ref4[0], setDuration = ref4[1];
    var ref5 = (0,react.useState)(), currentTime = ref5[0], setCurrentTime = ref5[1];
    var videoRef = (0,react.useRef)();
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,useIsHover/* useIsHover */.c)(), 2), isHover = ref6[0], mouseEvents = ref6[1];
    var springConfig = {
        interpolation: "basic",
        friction: 100,
        precision: 0.001,
        perfectStop: true
    };
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,useSpring/* useSpring */.q)({
        progress: 0,
        config: springConfig,
        onUpdate: function(e, prev) {
            return e.progress !== prev.progress && setVideoProgress(e.progress);
        }
    }), 1), setProgress = ref7[0];
    var updateProgress = function() {
        var ref;
        var time = videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.currentTime;
        setCurrentTime(time);
        var progress = currentTime / duration;
        !isNaN(progress) && setProgress({
            progress: progress
        });
    };
    var onDurationChange = function() {
        var ref;
        (videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.duration) && setDuration(videoRef.current.duration);
    };
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        onDurationChange();
    }, [
        metaDataLoaded
    ]);
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        var ref, ref1;
        isPlaying ? videoRef === null || videoRef === void 0 ? void 0 : (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play() : videoRef === null || videoRef === void 0 ? void 0 : (ref1 = videoRef.current) === null || ref1 === void 0 ? void 0 : ref1.pause();
    }, [
        isPlaying
    ]);
    (0,useIsomorphicLayoutEffect/* useIsomorphicLayoutEffect */.L)(function() {
        if (videoRef === null || videoRef === void 0 ? void 0 : videoRef.current) {
            isMuted ? videoRef.current.volume = 0 : videoRef.current.volume = 1;
        }
    }, [
        isMuted
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: VideoPlayerBasic_cx(className, (VideoPlayerBasic_styles_module_default()).VideoPlayer)
    }, mouseEvents), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Video/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                className: (VideoPlayerBasic_styles_module_default()).video,
                ref: videoRef,
                src: src,
                onTimeUpdate: updateProgress,
                onDurationChange: onDurationChange,
                onLoadedMetadata: function() {
                    return setMetaDataLoaded(true);
                }
            }, rest), {
                muted: isMuted
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer_VideoControls, {
                className: (VideoPlayerBasic_styles_module_default()).controls,
                videoDuration: duration,
                videoProgress: videoProgress,
                videoIsHover: isHover,
                videoPaused: !isPlaying,
                videoMuted: isMuted,
                videoHandleSeekTo: function(time) {
                    return console.log({
                        time: time
                    });
                },
                videoHandleMuteUnmute: function() {
                    return setIsMuted(function(prev) {
                        return !prev;
                    });
                },
                videoHandlePausePlay: function() {
                    return setIsPlaying(function(prev) {
                        return !prev;
                    });
                },
                videoIsLoading: false,
                // To Do : fix progress bar
                progressBarClassName: (VideoPlayerBasic_styles_module_default()).progressBar
            })
        ]
    }));
}
VideoPlayerBasic.defaultProps = {};
/* harmony default export */ var VideoPlayer_VideoPlayerBasic = (VideoPlayerBasic);

// EXTERNAL MODULE: ./src/components/Slices/HeroVideo/styles.module.scss
var HeroVideo_styles_module = __webpack_require__(80514);
var HeroVideo_styles_module_default = /*#__PURE__*/__webpack_require__.n(HeroVideo_styles_module);
;// CONCATENATED MODULE: ./src/components/Slices/HeroVideo/index.tsx





var HeroVideo_cx = bind_default().bind((HeroVideo_styles_module_default()));
function HeroVideo(param) {
    var className = param.className, videoSrc = param.videoSrc, image = param.image;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: HeroVideo_cx(className, (HeroVideo_styles_module_default()).HeroVideo),
        children: videoSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoPlayer_VideoPlayerBasic, {
            className: (HeroVideo_styles_module_default()).video,
            src: videoSrc,
            poster: (ref = image === null || image === void 0 ? void 0 : image.src) !== null && ref !== void 0 ? ref : null,
            loop: true,
            muted: true,
            autoPlay: true,
            playsInline: true
        })
    });
}
HeroVideo.defaultProps = {};
/* harmony default export */ var Slices_HeroVideo = (HeroVideo);

// EXTERNAL MODULE: ./src/components/Slices/ProductsGrid/index.tsx
var ProductsGrid = __webpack_require__(16197);
// EXTERNAL MODULE: ./src/components/Slices/ProductsPinsPush/index.tsx
var ProductsPinsPush = __webpack_require__(27733);
// EXTERNAL MODULE: ./src/components/Slices/PushCategories/index.tsx + 1 modules
var PushCategories = __webpack_require__(7817);
// EXTERNAL MODULE: ./src/components/Slices/PushGeneric/index.tsx + 1 modules
var PushGeneric = __webpack_require__(70544);
// EXTERNAL MODULE: ./src/components/Slices/PushSocial/index.tsx + 1 modules
var PushSocial = __webpack_require__(75562);
// EXTERNAL MODULE: ./src/components/Slices/PushStores/index.tsx + 1 modules
var PushStores = __webpack_require__(97014);
// EXTERNAL MODULE: ./src/components/Slices/PushTypeListing/index.tsx + 1 modules
var PushTypeListing = __webpack_require__(37923);
// EXTERNAL MODULE: ./src/components/Slices/ThreeColumnsImageWysiwyg/index.tsx
var ThreeColumnsImageWysiwyg = __webpack_require__(54165);
// EXTERNAL MODULE: ./src/components/Slices/TwoColumnsImageTitleWysiwygs/index.tsx
var TwoColumnsImageTitleWysiwygs = __webpack_require__(62549);
;// CONCATENATED MODULE: ./src/imports/home_page.ts















var _obj;
/* harmony default export */ var home_page = (_obj = {}, (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.HERO_SLIDER */.zj.HERO_SLIDER, HeroSlider/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_CATEGORIES */.zj.PUSH_CATEGORIES, PushCategories/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_GENERIC */.zj.PUSH_GENERIC, PushGeneric/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_STORES */.zj.PUSH_STORES, PushStores/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_SOCIAL */.zj.PUSH_SOCIAL, PushSocial/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PRODUCTS_GRID */.zj.PRODUCTS_GRID, ProductsGrid/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PUSH_DESIGNERS */.zj.PUSH_DESIGNERS, PushTypeListing/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.BIG_TITLE */.zj.BIG_TITLE, BigTitle/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.EDITORIAL_TITLE_PARAGRAPH_CTA */.zj.EDITORIAL_TITLE_PARAGRAPH_CTA, EditorialTitleParagraphCta/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.PRODUCTS_PINS_PUSH */.zj.PRODUCTS_PINS_PUSH, ProductsPinsPush/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS */.zj.TWO_COLUMNS_IMAGE_TITLE_WYSIWYGS, TwoColumnsImageTitleWysiwygs/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.THREE_COLUMNS_IMAGE_WYSIWYG */.zj.THREE_COLUMNS_IMAGE_WYSIWYG, ThreeColumnsImageWysiwyg/* default */.Z), (0,_define_property/* default */.Z)(_obj, storyblok_types/* STORYBLOK_SLICES.HERO_VIDEO */.zj.HERO_VIDEO, Slices_HeroVideo), _obj);

// EXTERNAL MODULE: ./src/components/Abstracts/SliceManager/index.tsx
var SliceManager = __webpack_require__(70820);
// EXTERNAL MODULE: ./src/components/PageViewAnalytics/index.tsx
var PageViewAnalytics = __webpack_require__(68971);
;// CONCATENATED MODULE: ./src/pages/index.tsx




function HomePage(param) {
    var slices = param.slices;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SliceManager/* default */.Z, {
                mapSliceTypeToComponent: home_page,
                slicesData: slices
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageViewAnalytics/* PageViewAnalytics */.W, {
                template: "index"
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);


/***/ }),

/***/ 60731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MuteUnmuteButton":"styles_MuteUnmuteButton__PDKsh"};

/***/ }),

/***/ 14583:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PlayPauseButton":"styles_PlayPauseButton__ixZX3"};

/***/ }),

/***/ 45592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ProgressBar":"styles_ProgressBar__ZLlI5","videoProgressContent":"styles_videoProgressContent__Le_32","videoProgressBar":"styles_videoProgressBar__uHgdN"};

/***/ }),

/***/ 60844:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VideoControls":"styles_VideoControls__EypPD","hide":"styles_hide__Z0X81","playpausebutton":"styles_playpausebutton__NhSn7","muteunmutebutton":"styles_muteunmutebutton__ba0H4","progressbar":"styles_progressbar__x91Wz"};

/***/ }),

/***/ 42296:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"VideoPlayer":"styles_VideoPlayer__vfrqV","video":"styles_video__91PQP","controls":"styles_controls__jLR0X","progressBar":"styles_progressBar__a4yd1"};

/***/ }),

/***/ 80514:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroVideo":"styles_HeroVideo__0Ce6m","video":"styles_video__zEjLK"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7924,7130,2873,3816,5750,6169,7421,9774,2888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);